// @ts-nocheck
/** *****
 * Store Custom Code:
 * For updates, compare with: modules\content-library\src\Widgets\ProductList\ProductListSortSelect.tsx
 * ****** */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Store Custom Code - Start */
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";

interface OwnProps extends WidgetProps, ExpandStyles<ProductListSortSelectStyles> {
    labelPosition?: "top" | "left";
    label?: string;
}
/* Store Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    pagination: getProductListDataViewProperty(state, "pagination"),
});

const mapDispatchToProps = {
    addProductFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps; // Store Custom Code

export interface ProductListSortSelectStyles {
    select?: SelectPresentationProps;
}

export const sortSelectStyles: ProductListSortSelectStyles = {
    // Store Removed - select
};

// Store Removed - styles

const ProductListSortSelect = ({
    addProductFilters,
    pagination,
    // Store Custom Code
    label,
    labelPosition = "left",
    extendedStyles,
    overridedStyles,
}: Props) => {
    const styles = useExpandProps(sortSelectStyles, extendedStyles, overridedStyles);

    if (!pagination?.totalItemCount /* Store Custom Code */) {
        return null;
    }

    const onChangeSortHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        addProductFilters({ sort: event.currentTarget.value });
    };

    return (
        <Select
            {...styles.select}
            label={label || translate("Sort by") /* Store Custom Code */}
            value={pagination.sortType}
            labelPosition={labelPosition /* Store Custom Code */}
            preventEllipsis={true}
            onChange={onChangeSortHandler}
            data-test-selector="productListSortSelect"
        >
            {pagination.sortOptions.map(sortOption => (
                <option key={sortOption.sortType} value={sortOption.sortType}>
                    {sortOption.displayName}
                </option>
            ))}
        </Select>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListSortSelect),
    definition: {
        group: "Product List",
        displayName: "Sort Select",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
